<script>
  import classNames from 'classnames';

  export let customClass = '';

  const wrapperClass = classNames('scmp_Buttons-wrapper', customClass);
</script>

<div class={wrapperClass}>
  <slot />
</div>
